<template>
<section>
    <v-app-bar color="primary" dark collapse fixed class="mainMenu">
        <v-menu bottom origin="center center" tile>
            <template v-slot:activator="{ on }">
                <v-btn icon x-large class="" active-class="no-active" v-on="on">
                    <v-img alt="Logo" class="shrink" contain src="@/assets/logo.svg" transition="scale-transition" width="44" />
                </v-btn>
            </template>
            <userMenu />
        </v-menu>
    </v-app-bar>
    <v-container fluid class="dashboard-container pt-1">
        <v-row align-content="center" justify="center" class="ma-0" no-gutters>
            <v-col cols="12" align="center" justify="center">
                <router-view />
            </v-col>
        </v-row>
    </v-container>
</section>
</template>

<script>
import MenuComponent from '../components/shared/Menu'
export default {
    name: 'Dashboard',
    components: {
        'userMenu': MenuComponent
    },
    methods: {
        verifyAccess() {
            if (this.$store.state.token === null) {
                this.$router.push('/');
            }
        }
    },
    created() {
        this.verifyAccess();
    },
}
</script>
